import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";
import { ExperimentIds } from "../commons/constants/experiment";
import { System } from "../commons/Constants";
import { FeedType } from "../types/LanderConfig";
import { isControlCohort } from "./helper";

export const YAHOO_MODERN_CONTROL = "YAHOO_MODERN_CONTROL";
export const YAHOO_MODERN_TREATMENT = "YAHOO_MODERN_TREATMENT";

export function useYahooModernExperiment() {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const inExperiment = key === ExperimentIds.yahooModernLander;
  const inTreatmentCohort = !!(
    inExperiment &&
    cohort &&
    !isControlCohort(cohort)
  );
  const isNotParkWeb = landerConfig.system !== System.PARKWEB;
  const isYahooFeed = landerConfig.lander?.feedID === FeedType.YAHOO;
  const isEligible = inExperiment && isNotParkWeb && isYahooFeed;
  const showModernLayout = isEligible && inTreatmentCohort;

  useEffect(() => {
    if (!isEligible) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_YAHOO_TYPE_TAG,
      payload: {
        typeTag: inTreatmentCohort
          ? YAHOO_MODERN_TREATMENT
          : YAHOO_MODERN_CONTROL,
      },
    });
  }, [isEligible, inTreatmentCohort, landerConfigDispatch]);

  return { showModernLayout, isEligible };
}
